/* --------------------------------------------------
   モバイル商品カード画像スライダー
   カスタム要素: <product-card-slider>
   無限ループ（タッチイベント検知） + プログレスバー
   -------------------------------------------------- */

class ProductCardSlider extends HTMLElement {
  connectedCallback() {
    this._track = this.querySelector('.product-card__slider-track');
    this._progressBar = this.querySelector('.product-card__slider-progress-bar');
    if (!this._track) return;

    this._slides = this._track.querySelectorAll('.product-card__slide');
    this._slideCount = this._slides.length;
    if (this._slideCount <= 1) return;

    // プログレスバー初期状態（1枚目）
    this._updateProgress();

    // スクロールイベント（rAFでthrottle）
    this._scrollRAF = null;
    this._track.addEventListener('scroll', () => {
      if (this._scrollRAF) return;
      this._scrollRAF = requestAnimationFrame(() => {
        this._updateProgress();
        this._scrollRAF = null;
      });
    }, { passive: true });

    // 無限ループ: タッチイベントでスワイプ方向を検知
    this._touchStartX = 0;
    this._touchStartIndex = 0;

    this._track.addEventListener('touchstart', (e) => {
      this._touchStartX = e.touches[0].clientX;
      const slideWidth = this._track.clientWidth;
      this._touchStartIndex = Math.round(this._track.scrollLeft / slideWidth);
    }, { passive: true });

    this._track.addEventListener('touchend', (e) => {
      const diff = this._touchStartX - e.changedTouches[0].clientX;
      // 最後のスライドで左方向にスワイプ（次へ進む操作）→ 1枚目に戻す
      if (diff > 30 && this._touchStartIndex >= this._slideCount - 1) {
        this._track.scrollTo({ left: 0, behavior: 'smooth' });
      }
    }, { passive: true });

    // リンクのクリック vs スワイプを区別
    this._pointerStartX = 0;
    this._track.addEventListener('pointerdown', (e) => { this._pointerStartX = e.clientX; }, { passive: true });
    this._track.addEventListener('click', (e) => {
      if (Math.abs(e.clientX - this._pointerStartX) > 10) {
        e.preventDefault();
      }
    });
  }

  _updateProgress() {
    if (!this._track || !this._progressBar) return;
    const maxScroll = this._track.scrollWidth - this._track.clientWidth;
    if (maxScroll <= 0) {
      this._progressBar.style.width = '100%';
      return;
    }
    const slideWidth = this._track.clientWidth;
    const currentIndex = Math.round(this._track.scrollLeft / slideWidth);
    const progressWidth = ((currentIndex + 1) / this._slideCount) * 100;
    this._progressBar.style.width = progressWidth + '%';
  }

  // スワッチ変更時にスライダーを先頭にリセット
  resetToFirst() {
    if (this._track) {
      this._track.scrollTo({ left: 0, behavior: 'instant' });
      this._updateProgress();
    }
  }
}

if (!window.customElements.get('product-card-slider')) {
  window.customElements.define('product-card-slider', ProductCardSlider);
}
